/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/lib/kubb-client'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from '@/lib/kubb-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import type { PostApiAuthLoginMutationRequest, PostApiAuthLoginMutationResponse, PostApiAuthLogin401 } from '../types/PostApiAuthLogin.ts'
import { useMutation } from '@tanstack/react-query'

export const postApiAuthLoginMutationKey = () => [{ url: '/api/auth/login' }] as const

export type PostApiAuthLoginMutationKey = ReturnType<typeof postApiAuthLoginMutationKey>

/**
 * @description Authenticate a user and return a JWT token
 * @summary User Login
 * {@link /api/auth/login}
 */
export async function postApiAuthLogin(
  data: PostApiAuthLoginMutationRequest,
  config: Partial<RequestConfig<PostApiAuthLoginMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const res = await request<PostApiAuthLoginMutationResponse, ResponseErrorConfig<PostApiAuthLogin401>, PostApiAuthLoginMutationRequest>({
    method: 'POST',
    url: `/api/auth/login`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

/**
 * @description Authenticate a user and return a JWT token
 * @summary User Login
 * {@link /api/auth/login}
 */
export function usePostApiAuthLogin<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostApiAuthLoginMutationResponse>,
      ResponseErrorConfig<PostApiAuthLogin401>,
      { data: PostApiAuthLoginMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostApiAuthLoginMutationRequest>> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? postApiAuthLoginMutationKey()

  return useMutation<
    ResponseConfig<PostApiAuthLoginMutationResponse>,
    ResponseErrorConfig<PostApiAuthLogin401>,
    { data: PostApiAuthLoginMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiAuthLogin(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}